import styled from "styled-components";
import Modal from "ui/common/components/feedback/Modal/Modal";

export const GiftcardVoucherModalRoot = styled(Modal)`
    &.giftcard-voucher-modal .title-content-body {
        padding: 0px 0px 30px 0px;
    }
`;
